<template>
  <div class="main">
    <!-- Add Sub Task Button -->
    <b-row class="align-items-center">
      <b-col md="8">
        <h3>{{ projectName }}</h3>
      </b-col>
      <b-col md="4">
        <div class="d-flex justify-content-end align-items-end">
          <!-- <b-form-checkbox
            v-model="displayKanban"
            name="check-button"
            switch
            inline
            class="ml-1"
          >
            Kanban
          </b-form-checkbox>-->
          <b-modal
            id="modal-add-subtask"
            ok-only
            ok-title="Add"
            centered
            size="lg"
            title="Add Sub Task"
            :hide-footer="true"
            ref="addProjectModal"
          >
            <SubTask
              :subtask="defaultSubTask"
              @taskAdded="closeAddProjectModal"
              :actionType="'add'"
              name="addSubTask"
            />
          </b-modal>
          <b-button variant="primary" v-b-modal.modal-add-subtask>
            <feather-icon icon="PlusIcon" class="" />
            Add Sub Task
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-modal
      id="modal-edit-subtask"
      ok-only
      ok-title="Edit"
      centered
      size="lg"
      title="Edit Sub Task"
      :hide-footer="true"
      ref="editProjectModal"
    >
      <SubTask
        :subtask="currentTask"
        @taskUpdated="closeEditProjectModal"
        :actionType="'edit'"
        name="editSubTask"
      />
    </b-modal>

    <!-- When Projects not available show this message -->
    <div v-if="subtasks.length === 0 && !loading">
      <b-row class="justify-content-center">
        <b-col md="4">
          <b-card>
            <b-card-body class="text-center">
              <h2>No subtasks available</h2>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- When Sub Task available show table or kanban -->
    <div class="d-block" v-else>
      <!-- Switch, toggle between task list and kanban -->
      <b-row class="justify-content-end my-1">
        <b-col md="6" class="d-flex justify-content-end align-items-center">
        </b-col>
      </b-row>

      <!-- Table row -->
      <b-row class="justify-content-between table-row" v-if="!displayKanban">
        <b-col md="2" sm="4" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="d-flex justify-content-end mb-2"
          style="position: relative; z-index: 1"
        >
          <b-button variant="outline-danger" size="sm" @click="clearFilters">
            Clear Filters
          </b-button>
        </b-col>

        <b-col cols="12" v-if="!loading">
          <div v-show="selectedOption === 'task'" class="table-task">
            <b-table
              striped
              hover
              responsive
              :items="filteredSubtasks"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <!-- Title Filter -->
              <template #head(title)="scope">
                <div class="d-flex flex-column">
                  <span>Title</span>
                  <b-form-input
                    v-model="filters.title"
                    placeholder="Filter by Title"
                    size="sm"
                    @input="applyFilters"
                  />
                </div>
              </template>

              <!-- Assignee(s) Filter -->
              <template #head(assigneeName)="scope">
                <div class="d-flex flex-column">
                  <span>Assignee(s)</span>
                  <b-form-input
                    v-model="filters.assigneeName"
                    placeholder="Filter by Assignee"
                    size="sm"
                    @input="applyFilters"
                  />
                </div>
              </template>

              <!-- Status Filter -->
              <template #head(status)="scope">
                <div class="d-flex flex-column">
                  <span>Status</span>
                  <b-form-select
                    v-model="filters.status"
                    :options="statusOptions"
                    placeholder="Select Status"
                    size="sm"
                    @change="applyFilters"
                  />
                </div>
              </template>

              <!-- End Date Filter -->
              <template #head(endDate)="scope">
                <div class="d-flex flex-column">
                  <span>End Date</span>
                  <DatePicker
                    v-model="filters.endDateRange"
                    range
                    format="YYYY-MM-DD"
                    placeholder="Select date range"
                    @change="applyFilters"
                    size="sm"
                  />
                </div>
              </template>

              <template #cell(status)="data">
                <b-badge :variant="statusMap[data.item.status].variant">
                  {{ statusMap[data.item.status].text }}
                </b-badge>
              </template>
              <template #cell(endDate)="data">
                <b-badge
                  v-if="
                    formatEndDate(data.item).isOverdue &&
                    formatEndDate(data.item).isCompleted === false
                  "
                  variant="danger"
                >
                  {{ formatEndDate(data.item).formattedDate }}
                </b-badge>
                <b-badge
                  v-else-if="
                    formatEndDate(data.item).isOverdue &&
                    formatEndDate(data.item).isCompleted === true
                  "
                  variant="success"
                >
                  {{ formatEndDate(data.item).formattedDate }}
                </b-badge>
                <span v-else>
                  {{ formatEndDate(data.item).formattedDate }}
                </span>
              </template>
              <!-- Priority Column -->
              <!-- <template #cell(priority)="data">
                <b-badge :variant="priorityMap[data.item.priority].variant">
                  {{ priorityMap[data.item.priority].text }}
                </b-badge>
              </template> -->
              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-b-modal.modal-edit-subtask
                    @click="EditTask(data.item)"
                  >
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="data.item.status === 'NOTSTARTED'"
                    @click="deleteProject(data.item.id)"
                  >
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="viewSubTaskDocument(data.item.id)">
                    <feather-icon icon="PaperclipIcon" />
                    <span class="align-middle ml-50">Documents</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>

          <b-modal
            ref="modal-view-document"
            id="modal-view-document"
            ok-only
            ok-title="View"
            centered
            size="lg"
            title="View Documents"
            :hide-footer="true"
          >
            <DocumentUpload
              @deleteFile="deleteFile"
              @downloadFile="downloadFile"
              @uploadFiles="uploadFiles"
              :documentDetails="documentDetails"
            />
          </b-modal>
        </b-col>

        <b-col cols="12">
          <div class="d-flex justify-content-center mb-1">
            <b-spinner
              variant="success"
              label="Spinning"
              block
              v-if="loading"
              style="width: 3rem; height: 3rem"
            ></b-spinner>
          </div>
          <b-pagination
            v-if="!loading"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>

      <!-- Kanban -->
      <!-- <b-row class="kanban-row" v-else>
        <b-col md="12">
          <TaskKanban :subtasks="subtasks" />
        </b-col>
      </b-row> -->
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import {
  BTable,
  BCardBody,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BSpinner,
  BFormCheckbox,
  BModal,
  VBModal,
} from "bootstrap-vue";

import {
  customSwal,
  customError,
  customLoader,
  formatDate,
} from "@/libs/customFn";
import SubTask from "./SubTask/SubTask.vue";
// import TaskKanban from "./Kanban.vue";
import DocumentUpload from "../component/DocumentUpload.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BCardBody,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BLink,
    BDropdownItem,
    SubTask,
    BSpinner,
    BFormCheckbox,
    DocumentUpload,
    //TaskKanban,
    VBModal,
    DatePicker,
  },
  data() {
    return {
      selectedOption: "task",
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentTask: {},
      currentPage: 1,
      projectName: null,
      filter: null,
      id: this.$route.params.id,
      taskId: this.$route.params.taskid,
      filterOn: [],
      displayKanban: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      filters: {
        title: "",
        assigneeName: "",
        status: null,
        endDateRange: [null, null],
      },
      filteredSubtasks: [], // Filtered subtasks
      statusOptions: [
        { value: null, text: "All" },
        { value: "NOTSTARTED", text: "Not Started" },
        { value: "INPROGRESS", text: "In Progress" },
        { value: "COMPLETED", text: "Completed" },
        { value: "ONHOLD", text: "On Hold" },
        // { value: "BLOCKED", text: "Blocked" },
        // { value: "REMOVED", text: "Removed" },
      ],
      fields: [
        { key: "title", label: "Title", sortable: true },
        { key: "assigneeName", label: "Assignee(s)", sortable: true },
        // { key: "priority", label: "Priority", sortable: true },
        { key: "status", label: "Status", sortable: true },
        {
          key: "endDate",
          label: "End Date",
          sortable: true,
          formatter: (value) => formatDate(value),
        },
        { key: "actions", label: "Actions" },
      ],
      fields_overdue: [
        { key: "title", label: "Title", sortable: true },
        { key: "assigneeName", label: "Assignee(s)", sortable: true },
        { key: "priority", label: "Priority", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "progress", label: "Progress", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      statusMap: {
        NOTSTARTED: { text: "Not Started", variant: "secondary" },
        NEW: { text: "New", variant: "primary" },
        INPROGRESS: { text: "In Progress", variant: "info" },
        ONHOLD: { text: "On Hold", variant: "warning" },
        COMPLETED: { text: "Completed", variant: "success" },
        BLOCKED: { text: "Blocked", variant: "danger" },
        REMOVED: { text: "Removed", variant: "dark" },
      },
      priorityMap: {
        NOTSPECIFIED: { text: "Not Specified", variant: "secondary" },
        LOW: { text: "Low", variant: "info" },
        MEDIUM: { text: "Medium", variant: "warning" },
        HIGH: { text: "High", variant: "danger" },
      },

      overdue_items: [
        {
          title: "Sub Task 1",
          assigneeName: "Assignee 1",
          priority: 1,
          status: 1,
          progress: 1,
        },
      ],
      priority: [
        {
          1: "High",
        },
        {
          1: "danger",
        },
      ],
      status: [
        {
          1: "Not started",
        },
        {
          1: "light-secondary",
        },
      ],
      progress: [
        {
          1: "Overdue",
        },
        {
          1: "light-danger",
        },
      ],
      defaultSubTask: {
        projectId: this.$route.params.id,
        tasksId: this.$route.params.taskid,
        status: "NOTSTARTED",
      },
      documentType: "SubTasks",
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
      currentSubTaskId: null,
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },

    ...mapGetters("projectModule", {
      projects: "projects",
      subtasks: "subtasks",
      loading: "loading",
    }),
    ...mapGetters("documentModule", {
      documents: "documents",
      file: "file",
      docloading: "docLoader",
    }),
  },
  async mounted() {
    this.totalRows = this.subtasks.length;
    await this.getProjectSubTasksAction({
      projectid: this.id,
      taskid: this.taskId,
    })
      .then((response) => {
        this.projectName = this.subtasks.map((item) => item.projectName)[0];
        this.filteredSubtasks = this.subtasks; // Initialize filtered tasks
        this.totalRows = this.filteredSubtasks.length; // Set total rows
      })
      .catch((response) => {
        console.log(response);
      });
  },
  methods: {
    ...mapActions("projectModule", [
      "getProjectSubTasksAction",
      "addProjectSubTaskAction",
      "removeProjectSubTaskAction",
      "updateProjectSubTaskAction",
    ]),
    ...mapActions("documentModule", [
      "getDocumentListAction",
      "removeDocumentAction",
      "fileSharingAction",
      "uploadDocumentAction",
      "uploadMultipleDocumentAction",
      "downloadDocumentAction",
    ]),
    applyFilters() {
      this.filteredSubtasks = this.subtasks.filter((subtask) => {
        const matchesTitle = subtask.title
          .toLowerCase()
          .includes(this.filters.title.toLowerCase());
        const matchesAssignee = subtask.assigneeName
          .toLowerCase()
          .includes(this.filters.assigneeName.toLowerCase());
        const matchesStatus =
          !this.filters.status || subtask.status === this.filters.status;
        const matchesEndDate =
          !this.filters.endDateRange[0] ||
          !this.filters.endDateRange[1] ||
          (new Date(subtask.endDate) >=
            new Date(this.filters.endDateRange[0]) &&
            new Date(subtask.endDate) <=
              new Date(this.filters.endDateRange[1]));

        return (
          matchesTitle && matchesAssignee && matchesStatus && matchesEndDate
        );
      });

      this.totalRows = this.filteredSubtasks.length; // Update pagination
    },
    clearFilters() {
      this.filters = {
        title: "",
        assigneeName: "",
        status: null,
        endDateRange: [null, null],
      };
      this.applyFilters(); // Reapply filters to reset the filteredSubtasks array
    },
    async viewSubTaskDocument(subTaskId) {
      this.currentSubTaskId = subTaskId;
      await this.getDocumentListAction({
        id: this.id,
        type: this.documentType,
        typeId: this.currentSubTaskId,
      });
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      this.$nextTick(() => {
        this.$bvModal.show("modal-view-document");
      });
    },
    formatEndDate(task) {
      if (!task.endDate) {
        return {
          formattedDate: "No Date",
          isOverdue: false,
          isCompleted: false,
        };
      }
      const date = new Date(task.endDate);
      const today = new Date();
      const isOverdue = date < today;
      const isCompleted = task.status === "COMPLETED";
      const formattedDate = date.toLocaleDateString();
      return { formattedDate, isOverdue, isCompleted };
    },

    async closeAddProjectModal() {
      this.$refs.addProjectModal.hide();

      this.defaultSubTask = {
        projectId: this.$route.params.id,
        tasksId: this.$route.params.taskid,
        status: "NOTSTARTED",
      };
      this.totalRows = this.subtasks.length;
    await this.getProjectSubTasksAction({
      projectid: this.id,
      taskid: this.taskId,
    })
      .then((response) => {
        //console.log("taskssssss4567890-sss");
        this.projectName = this.subtasks.map((item) => item.projectName)[0];
        this.filteredSubtasks = this.subtasks; // Initialize filtered tasks
        this.totalRows = this.filteredSubtasks.length; // Set total rows
      })
      .catch((response) => {
        console.log(response);
      });
    },

    async closeEditProjectModal() {
      this.$refs.editProjectModal.hide();
      await this.getProjectSubTasksAction({
        projectid: this.id,
        taskid: this.taskId,
      })
        .then((response) => {
          this.totalRows = this.subtasks.length;
        })
        .catch((response) => {
          console.log(response);
        });

      this.totalRows = this.projects.length;
    },

    EditTask(task) {
      this.currentTask = task;
    },

    deleteProject(smtpId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "Deleting...",
            text: "Please wait while the Sub Task are being deleted...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });

          //console.log("idddddddddddd", smtpId);
          this.removeProjectSubTaskAction(smtpId)
            .then((response) => {
              this.$swal.hideLoading();
              this.$swal.fire(
                "Deleted!",
                "Your Sub Task have been deleted.",
                "success"
              );
              this.getProjectSubTasksAction({
                projectid: this.id,
                taskid: this.taskId,
              })
                .then((response) => {
                  this.projectName = this.subtasks.map(
                    (item) => item.projectName
                  )[0];
                  this.filteredSubtasks = this.subtasks; // Initialize filtered tasks
                  this.totalRows = this.filteredSubtasks.length; // Set total rows
                })
                .catch((response) => {
                  console.log(response);
                });
            })
            .catch((error) => {
              this.$swal.fire(
                "Failed to Delete!",
                error.result || "There was a problem deleting the Sub Task.",
                "error"
              );
            });
        }
      });
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    deleteRow(index) {
      // Confirm deletion
      if (confirm("Are you sure you want to delete this row?")) {
        // Remove the item at the specified index from the items array
        this.items.splice(index, 1);
        // Optionally, you can refresh any dependent data or UI here
      }
    },
    selectOption(option) {
      this.selectedOption = option;
    },
    async downloadFile(id, fileName) {
      let loader = customLoader(
        "Please wait while the document is being prepared for download"
      );

      try {
        const response = await this.downloadDocumentAction(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = customLoader(
        "Please wait while the document(s) is being added"
      );
      const referenceId = this.id;

      if (selectedFiles.length > 1) {
        await this.uploadMultipleDocumentAction({
          payload: selectedFiles,
          referenceId: referenceId,
          type: this.documentType,
          typeId: this.currentSubTaskId,
        })
          .then((response) => {
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await this.uploadDocumentAction({
          payload: selectedFiles,
          referenceId: referenceId,
          type: this.documentType,
          typeId: this.currentSubTaskId,
        })
          .then((response) => {
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getDocumentListAction({
        id: referenceId,
        type: this.documentType,
        typeId: this.currentSubTaskId,
      });
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-document");
      });
    },
    async deleteFile(docId) {
      let loader = customLoader(
        "Please wait while the document is being deleted"
      );
      await this.removeDocumentAction(docId)
        .then((response) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customSwal();
        })
        .catch((error) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customError(error);
        });

      await this.getDocumentListAction({
        id: this.id,
        type: this.documentType,
        typeId: this.currentSubTaskId,
      });
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-document");
      });
    },
  },
};
</script>
